// How a client first found us — the lead source on every client (marketing
// foundation, CEO 2026-10-21). Shared by the API (validation, website mapping,
// backfill, analytics) and Flow (the New account picker, the Overview edit).
//
// null on a client = unknown. We never guess: old clients stay unknown unless
// we hold real evidence (a website record, or a commonsku id).

export const LEAD_SOURCES = [
  "website",
  "google_ads",
  "microsoft_ads",
  "linkedin",
  "meta",
  "chatgpt",
  "email",
  "referral",
  "existing_client_referral",
  "trade_show",
  "outbound",
  "repeat_from_commonsku",
  "other",
] as const;
export type LeadSource = (typeof LEAD_SOURCES)[number];

export const LEAD_SOURCE_LABEL: Record<LeadSource, string> = {
  website: "Website (found us on their own)",
  google_ads: "Google Ads",
  microsoft_ads: "Microsoft / Bing Ads",
  linkedin: "LinkedIn",
  meta: "Meta (Facebook / Instagram)",
  chatgpt: "ChatGPT",
  email: "Email campaign",
  referral: "Referral (partner / outside)",
  existing_client_referral: "Referral from an existing client",
  trade_show: "Trade show / event",
  outbound: "Outbound (we reached out)",
  repeat_from_commonsku: "Existing client (from commonsku)",
  other: "Other",
};

/** Sources a rep picks from on New account. "repeat_from_commonsku" is set by
 *  the backfill only; a brand-new account is never a commonsku client. */
export const REP_PICKABLE_LEAD_SOURCES: readonly LeadSource[] = LEAD_SOURCES.filter(
  (s) => s !== "repeat_from_commonsku",
);

export function isLeadSource(v: unknown): v is LeadSource {
  return typeof v === "string" && (LEAD_SOURCES as readonly string[]).includes(v);
}

/** Display label; null / anything unknown → "Unknown". */
export function leadSourceLabel(v: string | null | undefined): string {
  return isLeadSource(v) ? LEAD_SOURCE_LABEL[v] : "Unknown";
}
